const config = {
  recaptchasitekey: '6LftIEYUAAAAALhL3t4psFQValHhowhIKEpI586E',
  homeUrlkosen: 'https://www.procreditbank-direct.com/kosovo/en',
  homeUrlkossq: 'https://www.procreditbank-direct.com/kosovo/ksv',
  homeUrlkossr: 'https://www.procreditbank-direct.com/kosovo/rs',
  homeUrlmdaen: 'https://www.procreditbank-direct.com/moldova/en',
  homeUrlmdaro: 'https://www.procreditbank-direct.com/moldova/ro',
  homeUrlmdaru: 'https://www.procreditbank-direct.com/moldova/ru',
  homeUrl: 'https://www.procreditbank-direct.com/',
};
export default config;
